export {AppCommonComponent} from './app-common.component';
